import React, { useState } from "react";

import Paper from "Components/UI/Paper";

import { useNavigate, useLoaderData } from "react-router-dom";
import { postOptionById } from "API/swesum";
import usePost from "Hooks/usePost";
import { getOptionById, getCategories } from "API/swesum";
import OptionForm from "./OptionForm";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export async function loader({ params }) {
  const categories = await getCategories();
  const option = await getOptionById(params.optionID);

  return { option, categories };
}

export default function Option() {
  const { option, categories } = useLoaderData();

  const [formData, setFormData] = useState({
    Id: option.Id,
    Name: option.Name,
    Value: option.Value,
    Category: option.Category,
    SystemStatus: option.SystemStatus,
  });

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  // const { categories, option } = useLoaderData();
  const { openError } = usePopupNotificationContext();

  const updateCustomerReq = usePost({
    mtnFunc: (body) => postOptionById(option.Id, body),
    onError: () => {
      openError("Ett fel uppstod n�r Kontot skapades.");
    },
    onSuccess: () => {
      navigate("/options");
    },
  });

  const navigate = useNavigate();

  return (
    <Box>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h5" gutterBottom>
            {"Inställning - "}
            {option.Id}
          </Typography>
          <Grid
            container
            rowSpacing={4}
            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
          >
            <Grid item xs={12} md={12}>
              <Paper>
                <Typography
                  sx={{ marginBottom: "1.0rem" }}
                  variant="h5"
                  align="left"
                >
                  Inställningskort
                </Typography>
                <OptionForm
                  formData={formData}
                  categories={categories}
                  handleInputChange={handleInputChange}
                />
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button onClick={() => navigate(-1)} sx={{ ml: 1 }}>
                    Stäng
                  </Button>
                  <Button
                    onClick={() => updateCustomerReq.post(formData)}
                    variant="contained"
                    sx={{ ml: 3 }}
                  >
                    Spara
                  </Button>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
